<template>
  <div class="pt-10 mb-5 component" :class="{ 'telehealth-call': telehealthCallStatus }">
    <div class="nav-breadcrumb">
      <NavigationBreadcrumb :navigationWidth="navigationWidth" @toggleParticipant="toggleParticipant" :navigationOptions="navigationOptions"></NavigationBreadcrumb>
    </div>
    <div class="clear-float"></div>
    <PiiAndNonPiiInfo class="clear-both" v-if="participantInfo" :participantDetails="participantInfo"></PiiAndNonPiiInfo>
    <b-row>
      <b-col cols="12" class="p-0">
        <div v-if="generalInfo" class="task-navigation__current-task text-center ml-45 mr-45" id="task-navigation__current-task">
          <span class="current-task__title fw-500 fs-20 text-dark">{{ generalInfo.formName }}</span>
          <br />
          <div class="selectedResponse" ref="responsesDatesDropDown">
            {{ generalInfo.createdTime | formatUTCDate }}
          </div>
        </div>
        <ParticipantInfo
          class="mt-10"
          @verificationConfirmed="verificationConfirmed"
          @approvalConfirmed="approvalConfirmed"
          @reviewConfirmed="reviewConfirmed"
          @lockConfirmed="lockConfirmed"
          @signoffConfirmed="signoffConfirmed"
          v-if="participantInfo && generalInfo"
          :edcFormInfo="generalInfo"
          :participantDetails="participantInfo"
          :selectedLanguageCulture="selectedLanguageCulture"
          :languages="languages"
          :areActionsAllowed="{
            document: false,
            telehealth: true,
            edcforms: false,
            approval: true,
            verifyBtn: true
          }"
          @onLanguageChange="onLanguageChange"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="p-0">
        <b-card no-body class="border-0 shadow study-particip-form-block">
          <b-row v-if="edcFormHistoryVersion" no-gutters>
            <b-col>
              <EdcFormHistoryVersion :edcFormVersionData="edcFormHistoryVersion" @back="historyBack" />
            </b-col>
          </b-row>
          <b-row v-else no-gutters>
            <b-col
              :class="{
                'col-12': sourceDocumentsOpen,
                'col-8': !sourceDocumentsOpen
              }"
            >
              <b-tabs v-model="tabIndex">
                <b-tab title="Latest Version" @click="openTab(1)">
                  <template v-if="!edit">
                    <b-card-group
                      v-for="(unscheduleAnswers, index) in answersObj"
                      :key="index"
                      :class="{
                        'border-top': index > 0,
                        'pb-15': index + 1 === answersObj.length,
                        'pb-5': index + 1 !== answersObj.length
                      }"
                    >
                      <b-card no-body class="border-0" :header="unscheduleAnswers.formName">
                        <b-row>
                          <b-col>
                            <div v-if="checkIfEditCheckAllowed(unscheduleAnswers.formData) && (canPiAccess || canSubPiAccess || canScAccess || canInterviewerAccess || canHomeHealthAccess || canCallCenterAccess) && !user.readOnly && generalInfo && generalInfo.lockStatus === 'UNLOCKED'" class="float-right my-1">
                              <button-cmp v-if="!edit" @click="edit = !edit" size="sm" variant="outline-secondary">
                                <span>
                                  <i class="fa fa-pencil" aria-hidden="true"></i>
                                  Edit
                                </span>
                              </button-cmp>
                              <strong v-else class="editing">Currently editing</strong>
                            </div>
                          </b-col>
                        </b-row>

                        <template v-if="unscheduleAnswers.type == 'EDC'">
                          <SubmittedFormPreview v-if="unscheduleAnswers.formData" :formData="unscheduleAnswers.formData" @openQuery="openQuery" :queryIds="queryIds" @selected="filterByField" :selectedFieldId="filterFieldId" :selectedId="selectedId" />
                        </template>
                        <template v-else>
                          <ActivityFormPreview
                            key="RESPONSE"
                            :activityFormData="unscheduleAnswers.formData"
                            :formName="unscheduleAnswers.formData.name"
                            :mode="'RESPONSE'"
                            ref="activityFormPreview"
                            :queries="queries"
                            @openQuery="openQuery"
                            :queryIds="queryIds"
                            :lockStatus="generalInfo && generalInfo.lockStatus"
                            :trigger-validation="triggerValidate"
                            @disabledFields="disabledFields($event, unscheduleAnswers.formData)"
                            @selected="filterByField"
                            :selectedFieldId="filterFieldId"
                            :selectedId="selectedId"
                            :createdById="createdById"
                            :lang="languageCulture"
                            :showValidationMessage="showValidationMessage"
                            @onValidateAnswer="onValidateAnswer"
                            :validationCount="validationCount"
                          />
                        </template>
                      </b-card>
                    </b-card-group>
                  </template>
                  <template v-if="edit">
                    <div
                      v-for="(unscheduleForm, index) in unscheduledForms"
                      :key="index"
                      :class="{
                        formBorder: index != unscheduledForms.length - 1
                      }"
                    >
                      <label class="fs-14 pt-20 pl-30 m-0">
                        <b>{{ unscheduleForm.form.name }}</b>
                      </label>

                      <template v-if="unscheduleForm.form.type == 'EDC'">
                        <FormPreview :formData="unscheduleForm.form.fields" :formSubmitted="formSubmitted" :queryTool="true" />
                      </template>
                      <template v-else>
                        <ActivityFormPreview
                          :key="unscheduleForm.form.id"
                          :activityFormData="unscheduleForm.form"
                          :formName="unscheduleForm.form.name"
                          :formSubmitted="formSubmitted"
                          :trigger-validation="triggerValidate"
                          :queryTool="true"
                          :queries="queries"
                          :mode="'EDIT'"
                          :lockStatus="generalInfo && generalInfo.lockStatus"
                          @disabledFields="disabledFields($event, unscheduleForm.form)"
                          ref="activityFormPreview"
                          :createdById="createdById"
                          :lang="languageCulture"
                          @getQuestionScores="validateDataForScoring"
                          :showValidationMessage="showValidationMessage"
                          @onValidateAnswer="onValidateAnswer"
                          :validationCount="validationCount"
                        />
                      </template>
                    </div>
                    <b-row class="my-2 pl-30 pt-15 pb-15" align-v="center">
                      <b-col class="col-6 col-md-3">
                        <button variant="primary" :disabled="isSaveButtonDisabled" class="btn btn-block fs-14 btn-primary primaryBgColor pl-0 pr-0" @click="openChangeReasonModal">
                          Save
                        </button>
                      </b-col>
                      <b-col class="col-6 col-md-3">
                        <b-link class="fs-14 primary" @click="cancelEdit">Cancel</b-link>
                      </b-col>
                    </b-row>
                  </template>
                </b-tab>
                <b-tab title="History" v-if="!canSupportAccess && formHistory && formHistory.length" @click="checkEditMode">
                  <EdcFormHistoryList :history="formHistory" @view="viewHistoryForm" />
                </b-tab>
                <b-tab title="Source Documents" v-if="getDocuments && (canStudyAdminAccess || canPiAccess || canSubPiAccess || canScAccess || canHomeHealthAccess || canCraAccess || canSiteDataLockAccess || canCallCenterAccess || user.readOnly || canCraUBAccess)" @click="openTab(3)">
                  <EdcFormSourceDocuments :documents="documentsList" :studyId="studyId" :participantId="participantId" :responseId="unscheduledPacketResponseId" type="UNSCHEDULED" @getDocuments="getSourceDocuments" :participantInfo="participantInfo" />
                </b-tab>
                <b-tab title="Additional Scores" v-if="showAdditionalScores" @click="openTab(4)">
                  <EdcFormAdditionalScores :variablesList="variablesList" :responseId="responseId" :responseVersionId="responseVersionId" :studyId="studyId" :activityId="activityId" :participantId="participantId" :activityRevisionId="activityRevisionId"/>
                </b-tab>
              </b-tabs>
            </b-col>
            <b-col cols="5" xl="4" class="tabs-queries" v-if="sourceDocumentsOpen === false && participantInfo">
              <EdcFormQueries v-model="newQuery" :lockStatus="generalInfo && generalInfo.lockStatus" :filter="selectedId" @updateComment="updateComment" @updateQueries="getListOfQueries" :comments="comments" :queries="queries" :formId="fId" @openQuery="openQuery" @createQuery="createQuery" @createComment="createComment" @resetFilter="resetFilter" @onQueryClosed="onQueryClosed" @onQueryReopened="onQueryReopened" :siteId="participantInfo.siteId" />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <FormChangeReasonModal v-model="changeReasonModalVisible" @confirmed="updateUnschedulePacket" :openQueries="openQueries" />
    <!-- Cancel editing form confirmation  Modal Component -->
    <b-modal id="editFormModal" ref="editFormModal" @hidden="closeModal('editFormModal')" hide-footer hide-header :no-close-on-esc="true" :no-close-on-backdrop="true">
      <b-row class="pt-20 width-500 border-style text-center">
        <b-col align-self="center" class="pb-0 pl-0">
          <h2>
            <b>Warning</b>
          </h2>
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col align-self="center" class="pb-5 pt-5">Are you sure you want to cancel editing this form?</b-col>
      </b-row>
      <b-row class="pt-20 pb-40">
        <b-col cols="3"></b-col>
        <b-col cols="3">
          <b-btn class="btn-block fs-14" variant="secondary" @click="cancelAndCloseModal('editFormModal')">No</b-btn>
        </b-col>
        <b-col cols="3">
          <b-btn class="btn-block fs-14 error-bg primaryBgColor" variant="primary" @click="cancelEdit(), closeModal('editFormModal')">Yes</b-btn>
        </b-col>
      </b-row>
      <div class="modal-style"></div>
    </b-modal>
  </div>
</template>

<script>
import * as activityService from "@/components/services/activity-service";
import ParticipantInfo from "@/components/participants/participant-info-new";
import EdcFormHistoryList from "@/components/form/edc-form-history-list";
import EdcFormHistoryVersion from "@/components/form/edc-form-history-version";
import EdcFormQueries from "@/components/form/edc-form-queries";
import ButtonCmp from "@/components/common/button";
import FormPreview from "@/components/edc-form/form-preview";
import FormChangeReasonModal from "@/components/modals/form-change-reason-modal";
import SubmittedFormPreview from "@/components/edc-form/submitted-form-preview";
import EdcFormSourceDocuments from "@/components/form/edc-form-source-documents";
import EdcFormAdditionalScores from "@/components/form/edc-form-additional-scores";
import PiiAndNonPiiInfo from "@/components/participants/pii-and-non-pii-info";
import ActivityFormPreview from "@/components/activity-form/activity-form-preview";

import { AclRule } from "vue-acl";
import { mapActions, mapGetters } from "vuex";
import find from "lodash/find";
import each from "lodash/each";
import _ from "lodash";
import findIndex from "lodash/findIndex";
import difference from "lodash/difference";
import uniq from "lodash/uniq";
import cloneDeep from "lodash/cloneDeep";
import pull from "lodash/pull";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import MultilingualService from "@/components/services/multilingual-service";

import { PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, CRA, SITEDATALOCK, STUDY_ADMIN, INTERVIEWER, CC, CraUB, SUPPORT, DM, QUALITY, RATER, PHV, BSTAT } from "@/constants/authRoles";
import { formFieldQueryStatus } from "@/constants/form";
import NavigationBreadcrumb from "@/components/common/navigation-breadcrumb";

export default {
  name: "study-participant-form",
  components: {
    ParticipantInfo,
    EdcFormHistoryList,
    EdcFormHistoryVersion,
    EdcFormQueries,
    ButtonCmp,
    FormPreview,
    SubmittedFormPreview,
    FormChangeReasonModal,
    EdcFormSourceDocuments,
    EdcFormAdditionalScores,
    NavigationBreadcrumb,
    PiiAndNonPiiInfo,
    ActivityFormPreview
  },
  props: {
    studyId: {
      type: String
    },
    studyData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      totalScore: {},
      formSubmitted: 1,
      tabIndex: 0,
      participantInfo: null,
      formHistory: null,
      isLoading: true,
      newQuery: null,
      selectedId: null,
      edit: false,
      filterFieldId: null,
      generalInfo: null,
      participant: null,
      sections: [],
      queries: [],
      comments: [],
      formStudyId: this.$route.params.studyId,
      milestone: this.$route.params.milestone,
      participantId: this.$route.params.participantId,
      unscheduledPacketResponseId: this.$route.params.unscheduledPacketResponseId,
      packetId: this.$route.params.packetId,
      responseType: this.$route.params.responseType,
      formData: [],
      formResponses: {},
      unscheduledAnswers: [],
      alreadySavedUnscheduleForms: [],
      unscheduledForms: [],
      answersObj: [],
      historyAnswersObj: [],
      formErrors: [],
      modifiedUnscheduledForms: [],
      diffResp: [],
      unscheduledFormsHistory: [],
      edcFormHistoryVersion: null,
      queryIds: [],
      changeReasonModalVisible: false,
      siteTeam: {},
      unschedulePackets: null,
      sourceDocumentsOpen: false,
      documentsList: [],
      siteTeamDetails: [],
      getDocuments: false,
      latestVersionData: [],
      navigationOptions: [
        {
          name: "Profile",
          isLink: true,
          route: "participant-profile",
          params: { studyId: this.$route.params.studyId },
          displayOrder: 2
        },
        {
          name: "Participants",
          isLink: true,
          route: "study-participants-list",
          params: { studyId: this.$route.params.studyId },
          displayOrder: 1
        },
        {
          name: "Form Packet Details",
          isLink: false,
          route: null,
          params: null,
          displayOrder: 3
        }
      ],
      navigationWidth: "55%",
      telehealthCallStatus: false,
      disabledFieldsByBranchingLogic: [],
      createdById: "",
      triggerValidate: false,
      unsupportedQuestionType: ["ImageCapture", "MedicationSelector", "AudioRecording", "SurveyCompletion", "SurveyInstruction", "VideoRecording", "GPSkin", "Section", "WongBaker"],
      openQueries: [],
      selectedLanguageCulture: "EN",
      selectedLanguageId: "ca0af64b-9a40-11e9-8a9c-12046093208c",
      mlService: new MultilingualService(this.$route),
      taskInstanceId: this.$route.params.taskInstanceId,
      responseScores: {},
      showValidationMessage: false,
      validationCount: 0,
      isSaveButtonDisabled: false,
      displayAdditionalScoresAtLast: false,
      variablesList: [],
      activityId: "",
      responseId: "",
      responseVersionId: "",
      activityRevisionId: ""
    };
  },
  watch: {
    getVideoCallStatus(isCallInProgress) {
      this.telehealthCallStatus = isCallInProgress;
    },
    "formData.activityId": {
      deep: true,
      handler(value) {
        this.activityId = value;
        if (!!this.activityId) {
          this.getActivityVariablesList();
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getVideoCallStatus"]),
    fId() {
      return this.$route.params.packetId;
    },
    fieldsWithQueries() {
      if (this.queries) {
        return this.queries.filter(q => q.status === formFieldQueryStatus.OPEN).map(q => q.fieldId);
      }
      return [];
    },
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canScAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    languages() {
      if (this.studyData && this.studyData.language) {
        return this.studyData.language;
      }
      return [];
    },
    languageCulture() {
      return this.selectedLanguageCulture.includes("-") ? this.selectedLanguageCulture : this.selectedLanguageCulture.toLowerCase();
    },
    showAdditionalScores() {
      if (this.variablesList && this.variablesList.length > 0 && this.displayAdditionalScoresAtLast) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(["clearEDCFormErrors"]),
    disabledFields(fields, form, clear = false) {
      this.disabledFieldsByBranchingLogic[form.id] = fields;
      if (clear) {
        this.validationCount = this.validationCount + 1;
      }
    },
    removeDisabledFieldsFromRequiredFields(formId, requiredFieldIds) {
      const fieldsDisabled = [];
      if (this.disabledFieldsByBranchingLogic[formId]) {
        for (const [o, i] of Object.entries(this.disabledFieldsByBranchingLogic[formId])) {
          if (i == true) {
            fieldsDisabled.push(o);
          }
        }
      }
      return difference(requiredFieldIds, fieldsDisabled);
    },
    checkIfEditCheckAllowed(formData) {
      if (formData && formData.type != "EDC" && formData.activity) {
        if (formData.activity.allowDataEditChecks) {
          return true;
        }
        return false;
      }
      return true;
    },
    closeModal(ref) {
      this.$refs[ref].hide();
    },

    cancelAndCloseModal(ref) {
      this.tabIndex = 0;
      this.$refs[ref].hide();
    },

    showModal(ref) {
      this.$refs[ref].show();
    },

    checkEditMode() {
      this.openTab(2);
      if (this.edit) {
        this.showModal("editFormModal");
      }
    },

    openChangeReasonModal() {
      this.showValidationMessage = true;
      this.validationCount = this.validationCount + 1;
      this.changeReasonModalVisible = true;
    },

    // API integration to send Verify / Unverify form
    verificationConfirmed(status) {
      if (this.generalInfo.verificationStatus !== status) {
        const updateData = {
          action: status,
          verifyAction: true
        };
        this.$api
          .updateEdcUnscheduleFormResponseVersionsResource(this.alreadySavedUnscheduleForms.unscheduledPacketResponseId, this.latestVersionData.unscheduledPacketResponseVersionId, this.studyId, updateData)
          .then(() => {
            this.getEDCUnscheduledPacketForms();
            this.$toastr.success(`${status === "NOT_VERIFIED" ? "Unverification" : "Verification"} confirmed.`);
          })
          .catch(error => {
            const { message = "Error while saving verification status" } = (error && error.body) || {};
            this.$toastr.error(message);
          });
      }
    },

    // API integration to send approve / unapprove
    approvalConfirmed(status) {
      if (this.generalInfo.approvalStatus !== status) {
        const updateData = {
          action: status,
          approveAction: true
        };
        this.$api
          .updateEdcUnscheduleFormResponseVersionsResource(this.alreadySavedUnscheduleForms.unscheduledPacketResponseId, this.latestVersionData.unscheduledPacketResponseVersionId, this.studyId, updateData)
          .then(() => {
            this.getEDCUnscheduledPacketForms(true);
            this.$toastr.success(`${status === "APPROVED" ? "Approval confirmed." : "Unapproval confirmed."}`);
          })
          .catch(error => {
            const { message = "Error while saving approval status" } = (error && error.body) || {};
            this.$toastr.error(message);
          });
      }
    },

    reviewConfirmed(status) {
      if (this.generalInfo.reviewStatus !== status) {
        const updateData = {
          action: status,
          reviewAction: true
        };
        this.$api
          .updateEdcUnscheduleFormResponseVersionsResource(this.alreadySavedUnscheduleForms.unscheduledPacketResponseId, this.latestVersionData.unscheduledPacketResponseVersionId, this.studyId, updateData)
          .then(() => {
            this.getEDCUnscheduledPacketForms();
            this.$toastr.success(`${status === "REVIEWED" ? "Reviewed" : "Unreviewed"} confirmed.`);
          })
          .catch(error => {
            const { message = "Error while saving review status" } = (error && error.body) || {};
            this.$toastr.error(message);
          });
      }
    },
    lockConfirmed(status) {
      if (this.generalInfo.lockStatus !== status) {
        const updateData = {
          action: status,
          lockAction: true
        };
        this.$api
          .updateEdcUnscheduleFormResponseVersionsResource(this.alreadySavedUnscheduleForms.unscheduledPacketResponseId, this.latestVersionData.unscheduledPacketResponseVersionId, this.studyId, updateData)
          .then(() => {
            this.getEDCUnscheduledPacketForms();
            this.$toastr.success(`${status === "LOCKED" ? "Locked" : "Unlocked"} confirmed.`);
          })
          .catch(error => {
            const { message = "Error while saving lock status" } = (error && error.body) || {};
            this.$toastr.error(message);
          });
      }
    },
    signoffConfirmed(status) {
      if (this.generalInfo.signoffStatus !== status) {
        const data = [];
        data.push({
          action: status,
          responseId: this.unscheduledPacketResponseId,
          type: this.$route.query.type == "EDC_SCHEDULED" ? "SCHEDULED" : "UNSCHEDULED"
        });

        const requestParams = {
          studyId: this.studyId,
          taskType: "Packet"
        };

        this.$api
          .updateSignoff(requestParams, data)
          .then(() => {
            this.getEDCUnscheduledPacketForms();
            this.$toastr.success(`${status === "PENDING" ? "Unsigned off" : "Signed Off"} confirmed.`);
          })
          .catch(error => {
            const { message = "Error while saving sign off status" } = (error && error.body) || {};
            this.$toastr.error(message);
          });
      }
    },

    cancelEdit() {
      this.edit = false;
      this.getEDCUnscheduledPacketForms();
    },
    openQuery(fieldId) {
      this.newQuery = fieldId;
      this.selectedId = fieldId;
    },
    createQuery(query) {
      const reqObj = {
        responseId: this.alreadySavedUnscheduleForms.unscheduledPacketResponseId,
        fieldId: query.fieldId,
        responseType: "UNSCHEDULED",
        comment: {
          cText: query.comment
        }
      };
      this.$api
        .openNewQuery(reqObj, this.formStudyId)
        .then(() => {
          this.$toastr.success("Query created successfully.");
          this.getListOfQueries();
          this.selectedId = null;
        })
        .catch(error => {
          const { message = "Error while creating field query" } = (error && error.body) || {};
          this.$toastr.error(message);
        });
    },
    createComment(commentData) {
      const obj = {
        cText: commentData.comment
      };
      this.$api
        .addNewComment(commentData.queryId, this.formStudyId, obj)
        .then(() => {
          this.$api.getAllQueryComments(commentData.queryId, this.formStudyId).then(response => {
            this.comments = response.body.comments;
          });
        })
        .catch(error => {
          const { message = "Error while creating comment" } = (error && error.body) || {};
          this.$toastr.error(message);
        });
    },

    // API to fetch the saved form in history
    viewHistoryForm(versionForm) {
      //Prepare a reason for change string to display on the view history form.
      const createdDate = this.$options.filters.formatGMTDate(new Date(versionForm.createdAt));
      let reasonForChange = versionForm.primaryReason ? versionForm.primaryReason : "N/A";
      reasonForChange += ` ${createdDate} by ${versionForm.createdBy}`;
      this.$api
        .getedcUnscheduleFormResponseVersionsResourceV3(versionForm.responseId, versionForm.responseVerionId, this.studyId)
        .then(response => {
          this.unscheduledFormsHistory = [];
          this.alreadySavedUnscheduleForms = response.body;
          this.alreadySavedUnscheduleForms.packetFormResponses.forEach(result => {
            this.formResponses = result.response;
            if (this.formResponses.totalScore) {
              this.totalScore[result.form.id] = this.formResponses.totalScore;
            } else {
              this.totalScore[result.form.id] = 0;
            }
            this.formResponses.state = result.response.state;
            this.formData = result.form;
            if (this.formData.type == "EDC") {
              // send the saved answers to the corresponding form components
              if (this.formResponses && this.formResponses.answers && this.formResponses.answers.length) {
                // loop through the available answers
                this.formResponses.answers.forEach(answer => {
                  // get the field index in the saved formData using answer question ID
                  const selectedFieldIndex = findIndex(this.formData.fields, ["id", answer.questionId]);
                  // get the option which is saved as answer using option ID
                  const selectedOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                  // get index of the option in options array
                  // which is saved as answer using optionnId
                  const selectedOptionIndex = findIndex(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                  // In formData attach answer as well as the comment
                  // if the comment message is saved
                  this.formData.fields[selectedFieldIndex].answer = answer.answerText;
                  // for singlechoice the answer which is saved
                  // need's to be modified as per preview
                  if (this.formData.fields[selectedFieldIndex].name === "formSinglechoice" || this.formData.fields[selectedFieldIndex].name === "formDropdown") {
                    this.formData.fields[selectedFieldIndex].answer = answer.optionId;
                  }
                  if (selectedOption && selectedOption.type === "Other" && selectedOption.commentField) {
                    this.formData.fields[selectedFieldIndex].options[selectedOptionIndex].comment.commentMessage = answer.comment;
                  }
                  // for form scale we can have scale label or non scale labels as answer
                  if (this.formData.fields[selectedFieldIndex].name === "formScale") {
                    const selectedScaleOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                    if (selectedScaleOption.type === "NA" || selectedScaleOption.type === "Other") {
                      this.formData.fields[selectedFieldIndex].nonScaleAnswer = answer.answerText;
                      this.formData.fields[selectedFieldIndex].answer = null;
                    }
                  }
                  // for checkBox the options array which is saved
                  // need's to be modified as per preview
                  const tempOptions = [];
                  if (this.formData.fields[selectedFieldIndex].name === "formCheckbox") {
                    this.formData.fields[selectedFieldIndex].options.forEach((option, index) => {
                      const tempOption = option;
                      tempOption.answer = { unSelected: `${index + 1}` };
                      tempOption.value = option.label;
                      tempOption.selectVal = `${index + 1}`;
                      tempOptions.push(option);
                    });
                    answer.multiAnswer.forEach(ans => {
                      tempOptions[ans.index].answer = {
                        selected: tempOptions[ans.index].selectVal
                      };
                      if (tempOptions[ans.index].type === "Other" && tempOptions[ans.index].commentField) {
                        tempOptions[ans.index].comment.commentMessage = ans.comment;
                      }
                    });
                    this.formData.fields[selectedFieldIndex].options = tempOptions;
                  }
                  if (this.formData.fields[selectedFieldIndex].name === "formDateTime") {
                    if (answer.time) {
                      if (this.formData.fields[selectedFieldIndex].timeField.format === "hh:mm a") {
                        const timeVals = answer.time.split(" ");
                        const time = timeVals[0].split(":");
                        this.formData.fields[selectedFieldIndex].time = {
                          hh: time[0],
                          mm: time[1]
                        };
                        this.formData.fields[selectedFieldIndex].meridian = timeVals[1] || null;
                      } else if (this.formData.fields[selectedFieldIndex].timeField.format === "HH:mm") {
                        const time = answer.time.split(":");
                        this.formData.fields[selectedFieldIndex].time = {
                          HH: time[0],
                          mm: time[1]
                        };
                      }
                      this.formData.fields[selectedFieldIndex].timezone = answer.timezone;
                    }
                    if (answer.date) {
                      const dateVals = answer.date.split("/");
                      const dateFormat = pull(uniq(this.formData.fields[selectedFieldIndex].dateField.format), "/");
                      dateFormat.forEach((value, index) => {
                        if (value === "M") {
                          this.formData.fields[selectedFieldIndex].month = dateVals[index];
                        }
                        if (value === "D") {
                          this.formData.fields[selectedFieldIndex].date = dateVals[index];
                        }
                        if (value === "Y") {
                          this.formData.fields[selectedFieldIndex].year = dateVals[index];
                        }
                      });
                    }
                  }
                  // for table the fields array which is saved need's
                  // to be modified as per preview
                  const tempTableOptions = [];
                  if (this.formData.fields[selectedFieldIndex].name === "formTable") {
                    // for the available fields add the answer which are configured
                    // at form creation
                    if (this.formData.fields[selectedFieldIndex].noOfFields) {
                      for (let ind = 0; ind < this.formData.fields[selectedFieldIndex].noOfFields; ind++) {
                        tempTableOptions.push({
                          index: ind,
                          type: "OPTION",
                          label: ""
                        });
                      }
                    }
                    // Add the answer to fields which are not configured
                    // while form creation but added by user
                    const tempTableUserOptions = [];
                    if (answer.multiAnswer.length > this.formData.fields[selectedFieldIndex].noOfFields) {
                      for (let ind = this.formData.fields[selectedFieldIndex].noOfFields; ind < answer.multiAnswer.length; ind++) {
                        tempTableUserOptions.push({
                          index: ind,
                          type: "OPTION",
                          label: ""
                        });
                      }
                    }

                    // attach answers to the generated fields and user added fields
                    answer.multiAnswer.forEach((ans, index) => {
                      if (index < this.formData.fields[selectedFieldIndex].noOfFields) {
                        tempTableOptions[index].label = ans.answerText;
                      }
                      if (index >= this.formData.fields[selectedFieldIndex].noOfFields) {
                        tempTableUserOptions[index - this.formData.fields[selectedFieldIndex].noOfFields].label = ans.answerText;
                      }
                    });
                    this.formData.fields[selectedFieldIndex].fields = tempTableOptions;
                    this.formData.fields[selectedFieldIndex].addFields = tempTableUserOptions;
                  }
                });
              }
              // add the mode for each form component to display as preview
              const formFields = [];
              this.formData.fields.forEach(field => {
                const formField = field;
                formField.mode = "saved";
                formFields.push(formField);
              });
              this.formData.fields = formFields;
              this.unscheduledFormsHistory.push({
                form: this.formData,
                response: this.formResponses || [],
                editedFields: result.editedFields || []
              });
            } else {
              if (this.formResponses && this.formResponses.answers && this.formResponses.answers.length) {
                // loop through the available answers
                this.formResponses.answers.forEach(answer => {
                  // get the field index in the saved formData using answer question ID
                  const selectedFieldIndex = findIndex(this.formData.activity.questions, ["id", answer.questionId]);
                  // In formData attach answer as well as the comment
                  // if the comment message is saved
                  this.formData.activity.questions[selectedFieldIndex].answer = answer.answerText;
                });
              }
              // add the mode for each form component to display as preview
              const questions = [];
              this.formData.activity.questions.forEach(question => {
                const formQuestion = question;
                formQuestion.mode = "saved";
                questions.push(formQuestion);
              });
              this.formData.activity.questions = questions;
              this.unscheduledFormsHistory.push({
                form: this.formData,
                response: this.formResponses || [],
                editedFields: result.editedFields || []
              });
            }
          });
          this.historyAnswersObj = [];
          this.modifiedUnscheduledForms = cloneDeep(this.unscheduledFormsHistory);
          // questions and answers object for display
          this.unscheduledFormsHistory.forEach(unscheduleform => {
            const answerObj = [];
            if (unscheduleform.form.type == "EDC") {
              each(unscheduleform.form.fields, question => {
                const newObj = {};
                newObj.question = question.body;
                newObj.name = question.name;
                newObj.id = question.id;
                if (question.name !== "formHeader" && question.name !== "formParagraph") {
                  newObj.sequence = question.sequence;
                }
                const resObj = find(unscheduleform.response.answers, answer => answer.questionId === question.id);
                if (resObj) {
                  if (resObj.questionName === "formCheckbox" || resObj.questionName === "formTable") {
                    newObj.answerText = resObj.multiAnswer;
                    if (resObj.comment && resObj.comment !== "this is not valid") {
                      newObj.answerText = `${resObj.answerText} - ${resObj.comment}`;
                    }
                    //Implemented this code for Previous values
                    newObj.previousAnswerText = resObj.previousMultiAnswer;
                    newObj.computedScore = resObj.score;
                    newObj.previousScore = resObj.previousScore;
                    newObj.actualScore = resObj.actualScore;
                    newObj.previousActualScore = resObj.previousActualScore;
                    if (resObj.previousComment && resObj.previousComment !== "this is not valid") {
                      newObj.previousAnswerText = `${resObj.previousMultiAnswer} - ${resObj.previousComment}`;
                    }
                    //New Code End
                  } else if (resObj.questionName === "formDateTime") {
                    newObj.answerText = `${resObj.date || ""} ${resObj.time || ""} ${resObj.timezone || ""}`;
                    newObj.previousAnswerText = `${resObj.previousDate || ""} ${resObj.previousTime || ""} ${resObj.previousTimezone || ""}`;
                    newObj.computedScore = resObj.score;
                    newObj.previousScore = resObj.previousScore;
                    newObj.actualScore = resObj.actualScore;
                    newObj.previousActualScore = resObj.previousActualScore;
                  } else {
                    newObj.answerText = resObj.answerText;
                    newObj.computedScore = resObj.score;
                    newObj.previousScore = resObj.previousScore;
                    newObj.actualScore = resObj.actualScore;
                    newObj.previousActualScore = resObj.previousActualScore;

                    if (resObj.comment && resObj.comment !== "this is not valid") {
                      newObj.answerText = `${resObj.answerText} - ${resObj.comment}`;
                    }
                    newObj.previousAnswerText = resObj.previousAnswerText;
                    if (resObj.previousComment && resObj.previousComment !== "this is not valid") {
                      newObj.previousAnswerText = `${resObj.previousAnswerText} - ${resObj.previousComment}`;
                    }
                  }
                } else {
                  newObj.answerText = "";
                  newObj.computedScore = 0;
                  newObj.actualScore = 0;
                }
                newObj.isEditedVersion = unscheduleform.editedFields && unscheduleform.editedFields.includes(question.id);
                answerObj.push(newObj);
              });
              this.historyAnswersObj.push({
                formName: unscheduleform.form.name,
                formData: answerObj,
                type: unscheduleform.form.type,
                primaryReason: reasonForChange
              });
            } else {
              each(unscheduleform.form.activity.questions, question => {
                const resObj = find(unscheduleform.response.answers, answer => answer.questionId === question.id);

                if (resObj) {
                  if (resObj.questionName === "MultiChoice" || resObj.questionName === "Image") {
                    question.answer = resObj.answerText;
                    question.previousAnswer = resObj.previousAnswerText;
                    const optionsIds = _.cloneDeep(resObj.optionsIds);
                    question.optionsIds = resObj.optionsIds ? optionsIds : [];

                    question.subType = resObj.subType;
                    question.previousSubType = resObj.previousSubType;
                    question.previousOptionsIds = resObj.previousOptionsIds;
                  } else if (resObj.questionName === "DateTime") {
                    question.answer = resObj.answerText;
                    question.previousAnswer = resObj.previousAnswerText;

                    question.date = resObj.date;
                    question.time = resObj.time;
                    question.dateFormat = resObj.dateFormat;
                    question.timeFormat = resObj.timeFormat;
                    question.previousDate = resObj.previousDate;
                    question.previousTime = resObj.previousTime;
                    question.previousDateFormat = resObj.previousDateFormat;
                    question.previousTimeFormat = resObj.previousTimeFormat;
                  } else if (resObj.questionName == "Boolean") {
                    question.answer = resObj.answerText;
                    question.answerId = resObj.answerId;

                    question.previousAnswer = resObj.previousAnswerText;
                    question.previousAnswerId = resObj.previousAnswerId;
                  } else if (resObj.questionName == "Log") {
                    question.multiAnswer = _.cloneDeep(resObj.multiAnswer);
                    question.answerId = resObj.answerId;

                    question.previousMultiAnswer = resObj.previousMultiAnswer;
                    question.previousAnswerId = resObj.previousAnswerId;
                  } else if (resObj.questionName == "DropDown") {
                    question.answer = resObj.answerText;
                    question.optionId = resObj.optionId;
                    question.index = resObj.index;
                    question.answerId = resObj.answerId;
                    question.previousAnswer = resObj.previousAnswerText;
                    question.previousAnswerId = resObj.previousAnswerId;
                  } else {
                    question.answer = resObj.answerText;
                    question.previousAnswer = resObj.previousAnswerText;
                  }
                  question.computedScore = resObj.score || 0;
                  question.previousScore = resObj.previousScore || 0;
                  question.actualScore = resObj.actualScore || 0;
                  question.previousActualScore = resObj.previousActualScore || 0;
                } else {
                  question.answer = "";
                  if (question.type != "Section") {
                    question.computedScore = 0;
                    question.actualScore = 0;
                  }
                }
                question.isEditedVersion = unscheduleform.editedFields && unscheduleform.editedFields.includes(question.id);
              });
              const activityData = {};
              activityData.id = unscheduleform.form;
              this.historyAnswersObj.push({
                formName: unscheduleform.form.name,
                type: unscheduleform.form.type,
                formData: unscheduleform.form,
                primaryReason: reasonForChange
              });
            }
          });
          this.edcFormHistoryVersion = {
            fields: this.historyAnswersObj,
            isUnSchedule: true
          };
        })
        .catch(error => {
          const { message = "Error while getting form version" } = (error && error.body) || {};
          this.$toastr.error(message);
        });
    },

    historyBack() {
      this.edcFormHistoryVersion = null;
    },
    filterByField(id) {
      this.selectedId = id;
    },
    resetFilter() {
      this.filterFieldId = null;
      this.selectedId = null;
    },
    onQueryClosed(query) {
      this.$api
        .updateQueryStatus(query.queryId, this.formStudyId, "CLOSE")
        .then(() => {
          this.$toastr.success("Query closed");
          this.getListOfQueries();
          this.selectedId = null;
        })
        .catch(error => {
          const { message = "Error while closing query" } = (error && error.body) || {};
          this.$toastr.error(message);
        });
    },
    onQueryReopened(query) {
      this.$api
        .updateQueryStatus(query.queryId, this.formStudyId, "OPEN")
        .then(() => {
          this.$toastr.success("Query reopened successfully.");
          this.getListOfQueries();
          this.selectedId = null;
        })
        .catch(error => {
          const { message = "Error while reopening query" } = (error && error.body) || {};
          this.$toastr.error(message);
        });
    },

    getListOfOpenQueries() {
      this.$api.getAllListOfOpenQueries(this.alreadySavedUnscheduleForms.unscheduledPacketResponseId, this.formStudyId).then(response => {
        this.openQueries = response.body;
      });
    },

    // get list of queries mapped to the current form
    getListOfQueries() {
      this.$api.getAllListOfQueries(this.alreadySavedUnscheduleForms.unscheduledPacketResponseId, this.formStudyId).then(response => {
        this.queries = response.body;
        this.queryIds = map(response.body.filter(resp => resp.status === "OPEN"), "fieldId");
        this.queries.forEach((query, queryIndex) => {
          query.comments.forEach((comment, commentIndex) => {
            const tempComment = comment;
            tempComment.createdBy = this.siteTeam[comment.createdBy];
            this.queries[queryIndex].comments[commentIndex] = tempComment;
          });
        });
      });
    },

    // get site team members
    async getSiteTeam() {
      const studyTeamData = await this.$api.getStudyTeamFact(this.$route.params.studyId);
      const siteTeamData = await this.$api.getUserNames(this.$route.params.studyId);
      studyTeamData.body.forEach(team => {
        this.siteTeam[team.id] = `${team.firstName} ${team.lastName}`;
        const siteTeamObj = {};
        siteTeamObj["id"] = team.id;
        siteTeamObj["name"] = `${team.firstName} ${team.lastName}`;
        siteTeamObj["userRole"] = team.userRole;
        this.siteTeamDetails.push(siteTeamObj);
      });
      siteTeamData.body.forEach(team => {
        this.siteTeam[team.id] = `${team.firstName} ${team.lastName}`;
        const siteTeamObj = {};
        siteTeamObj["id"] = team.id;
        siteTeamObj["name"] = `${team.firstName} ${team.lastName}`;
        siteTeamObj["userRole"] = team.userRole;
        this.siteTeamDetails.push(siteTeamObj);
      });
      await this.getParticipantDetails();
      await this.getUnschduledPacketInfo();
    },

    // get the participant details
    async getParticipantDetails() {
      await this.$api.getParticipantDataFactV2(this.formStudyId, this.participantId).then(
        response => {
          this.participantInfo = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },

    // get edc form history list
    getEDCFormHistoryList() {
      this.$api
        .getEdcQueryFormVersionsHistoryStatus(this.formId, this.alreadySavedUnscheduleForms.unscheduledPacketResponseId, this.studyId, this.responseType)
        .then(result => {
          this.formHistory = orderBy(result.body, ["createdAt"], ["desc"]);
          this.formHistory.forEach((form, formIndex) => {
            this.formHistory[formIndex].createdBy = this.siteTeam[form.createdBy];
          });
          this.getDocuments = true;
          // displayAdditionalScoresAtLast made this true so that it can be seen in the last tab
          this.displayAdditionalScoresAtLast = true;
        })
        .catch(error => {
          this.displayAdditionalScoresAtLast = true;
          this.formHistory = [];
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Unable to fetch the form versions history.");
        });
    },
    getUnschduledPacketInfo() {
      const self = this;
      this.$api.getEDCUnscheduleFormResponseFact(this.studyId, this.$route.params.participantId).then(
        response => {
          if (response.body && response.body.length > 0) {
            self.unschedulePackets = response.body.filter(packet => {
              return packet.unscheduledPacketId == this.packetId;
            });
          }
          self.getEDCUnscheduledPacketForms();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting Unscheduled Packet information.");
        }
      );
    },

    // get the unscheduled packets details
    getEDCUnscheduledPacketForms(updateEDCUnscheduledPacketForms) {
      this.$api
        .getUnscheduleFormResponseFactV3(this.studyId, this.participantId, this.packetId, this.unscheduledPacketResponseId)
        .then(response => {
          this.unscheduledForms = [];
          this.alreadySavedUnscheduleForms = response.body;
          this.responseId = response.body.packetFormResponses[0].response.responseId;
          this.responseVersionId = response.body.packetFormResponses[0].response.responseVersionId;
          this.latestVersionData = response.body;
          if (updateEDCUnscheduledPacketForms) {
            this.$root.$emit("updateScoreValueTab", this.responseVersionId, this.responseId);
          }
          if (response.body.responseVersionCreatedBy) {
            this.createdById = response.body.responseVersionCreatedBy;
          }
          // get the form history versions
          this.getEDCFormHistoryList();
          // get the list of queries mapped to the current form
          this.getListOfQueries();
          this.getListOfOpenQueries();
          this.getSourceDocuments();
          this.alreadySavedUnscheduleForms.packetFormResponses.forEach(result => {
            this.formResponses = result.response;
            this.formResponses.state = result.response.state;
            this.formData = result.form;
            if (this.formData && this.formData.type == "EDC") {
              // send the saved answers to the corresponding form components
              if (this.formResponses && this.formResponses.answers && this.formResponses.answers.length) {
                // loop through the available answers
                this.formResponses.answers.forEach(answer => {
                  // get the field index in the saved formData using answer question ID
                  const selectedFieldIndex = findIndex(this.formData.fields, ["id", answer.questionId]);
                  // get the option which is saved as answer using option ID
                  const selectedOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                  // get index of the option in options array
                  // which is saved as answer using optionnId
                  const selectedOptionIndex = findIndex(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                  // In formData attach answer as well as the comment
                  // if the comment message is saved
                  this.formData.fields[selectedFieldIndex].answer = answer.answerText;
                  // for singlechoice the answer which is saved
                  // need's to be modified as per preview
                  if (this.formData.fields[selectedFieldIndex].name === "formSinglechoice" || this.formData.fields[selectedFieldIndex].name === "formDropdown") {
                    this.formData.fields[selectedFieldIndex].answer = answer.optionId;
                  }
                  if (selectedOption && selectedOption.type === "Other" && selectedOption.commentField) {
                    this.formData.fields[selectedFieldIndex].options[selectedOptionIndex].comment.commentMessage = answer.comment;
                  }
                  // for form scale we can have scale label or non scale labels as answer
                  if (this.formData.fields[selectedFieldIndex].name === "formScale") {
                    const selectedScaleOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                    if (selectedScaleOption.type === "NA" || selectedScaleOption.type === "Other") {
                      this.formData.fields[selectedFieldIndex].nonScaleAnswer = answer.answerText;
                      this.formData.fields[selectedFieldIndex].answer = null;
                    }
                  }
                  // for checkBox the options array which is saved
                  // need's to be modified as per preview
                  const tempOptions = [];
                  if (this.formData.fields[selectedFieldIndex].name === "formCheckbox") {
                    this.formData.fields[selectedFieldIndex].options.forEach((option, index) => {
                      const tempOption = option;
                      tempOption.answer = { unSelected: `${index + 1}` };
                      tempOption.value = option.label;
                      tempOption.selectVal = `${index + 1}`;
                      tempOptions.push(option);
                    });
                    answer.multiAnswer.forEach(ans => {
                      tempOptions[ans.index].answer = {
                        selected: tempOptions[ans.index].selectVal
                      };
                      if (tempOptions[ans.index].type === "Other" && tempOptions[ans.index].commentField) {
                        tempOptions[ans.index].comment.commentMessage = ans.comment;
                      }
                    });
                    this.formData.fields[selectedFieldIndex].options = tempOptions;
                  }
                  if (this.formData.fields[selectedFieldIndex].name === "formDateTime") {
                    if (answer.time) {
                      if (this.formData.fields[selectedFieldIndex].timeField.format === "hh:mm a") {
                        const timeVals = answer.time.split(" ");
                        const time = timeVals[0].split(":");
                        this.formData.fields[selectedFieldIndex].time = {
                          hh: time[0],
                          mm: time[1]
                        };
                        this.formData.fields[selectedFieldIndex].meridian = timeVals[1] || null;
                      } else if (this.formData.fields[selectedFieldIndex].timeField.format === "HH:mm") {
                        const time = answer.time.split(":");
                        this.formData.fields[selectedFieldIndex].time = {
                          HH: time[0],
                          mm: time[1]
                        };
                      }
                      this.formData.fields[selectedFieldIndex].timezone = answer.timezone;
                    }
                    if (answer.date) {
                      const dateVals = answer.date.split("/");
                      const dateFormat = pull(uniq(this.formData.fields[selectedFieldIndex].dateField.format), "/");
                      dateFormat.forEach((value, index) => {
                        if (value === "M") {
                          this.formData.fields[selectedFieldIndex].month = dateVals[index];
                        }
                        if (value === "D") {
                          this.formData.fields[selectedFieldIndex].date = dateVals[index];
                        }
                        if (value === "Y") {
                          this.formData.fields[selectedFieldIndex].year = dateVals[index];
                        }
                      });
                    }
                  }
                  // for table the fields array which is saved need's
                  // to be modified as per preview
                  const tempTableOptions = [];
                  if (this.formData.fields[selectedFieldIndex].name === "formTable") {
                    // for the available fields add the answer which are configured
                    // at form creation
                    if (this.formData.fields[selectedFieldIndex].noOfFields) {
                      for (let ind = 0; ind < this.formData.fields[selectedFieldIndex].noOfFields; ind++) {
                        tempTableOptions.push({
                          index: ind,
                          type: "OPTION",
                          label: ""
                        });
                      }
                    }
                    // Add the answer to fields which are not configured
                    // while form creation but added by user
                    const tempTableUserOptions = [];
                    if (answer.multiAnswer.length > this.formData.fields[selectedFieldIndex].noOfFields) {
                      for (let ind = this.formData.fields[selectedFieldIndex].noOfFields; ind < answer.multiAnswer.length; ind++) {
                        tempTableUserOptions.push({
                          index: ind,
                          type: "OPTION",
                          label: ""
                        });
                      }
                    }

                    // attach answers to the generated fields and user added fields
                    answer.multiAnswer.forEach((ans, index) => {
                      if (index < this.formData.fields[selectedFieldIndex].noOfFields) {
                        tempTableOptions[index].label = ans.answerText;
                      }
                      if (index >= this.formData.fields[selectedFieldIndex].noOfFields) {
                        tempTableUserOptions[index - this.formData.fields[selectedFieldIndex].noOfFields].label = ans.answerText;
                      }
                    });
                    this.formData.fields[selectedFieldIndex].fields = tempTableOptions;
                    this.formData.fields[selectedFieldIndex].addFields = tempTableUserOptions;
                  }
                });
              }
              // add the mode for each form component to display as preview
              const formFields = [];
              this.formData.fields.forEach(field => {
                const formField = field;
                formField.mode = "saved";
                formFields.push(formField);
              });
              this.formData.fields = formFields;
            } else {
              activityService.setRequiredFieldsOnEachStep(this);
            }
            this.unscheduledForms.push({
              form: this.formData,
              response: this.formResponses || []
            });
          });
          this.modifiedUnscheduledForms = cloneDeep(this.unscheduledForms);
          // questions and answers object for display
          this.answersObj = [];
          this.unscheduledForms.forEach(unscheduleform => {
            const answerObj = [];
            if (unscheduleform.form.type == "EDC") {
              each(unscheduleform.form.fields, question => {
                const newObj = {};
                newObj.question = question.body;
                newObj.name = question.name;
                newObj.id = question.id;
                if (question.name !== "formHeader" && question.name !== "formParagraph") {
                  newObj.sequence = question.sequence;
                }
                const resObj = find(unscheduleform.response.answers, answer => answer.questionId === question.id);
                if (resObj) {
                  if (resObj.questionName === "formCheckbox" || resObj.questionName === "formTable") {
                    if (resObj.questionName === "formCheckbox") {
                      resObj.multiAnswer.forEach(answer => {
                        question.options.forEach(option => {
                          if (answer.optionId === option.id) {
                            if (option.colorCoding) {
                              answer.colorCoding = option.colorCoding;
                            }
                          }
                        });
                      });
                      newObj.noOfColumns = question.noOfColumns;
                    }
                    newObj.answerText = resObj.multiAnswer;
                    if (resObj.comment && resObj.comment !== "this is not valid") {
                      newObj.answerText = `${resObj.answerText} - ${resObj.comment}`;
                    }
                  } else if (resObj.questionName === "formDateTime") {
                    newObj.answerText = `${resObj.date || ""} ${resObj.time || ""} ${resObj.timezone || ""}`;
                  } else {
                    if (resObj.questionName === "formSinglechoice") {
                      const optionObj = find(question.options, option => resObj.optionId === option.id);
                      if (optionObj.colorCoding) {
                        newObj.colorCoding = optionObj.colorCoding;
                      }
                    }
                    newObj.answerText = resObj.answerText;
                    if (resObj.comment && resObj.comment !== "this is not valid") {
                      newObj.answerText = `${resObj.answerText} - ${resObj.comment}`;
                    }
                  }
                } else {
                  newObj.answerText = "";
                }
                answerObj.push(newObj);
              });
              this.answersObj.push({
                formName: unscheduleform.form.name,
                type: unscheduleform.form.type,
                formData: answerObj,
                formId: unscheduleform.form.id
              });
            } else {
              each(unscheduleform.form.activity.questions, question => {
                const resObj = find(unscheduleform.response.answers, answer => answer.questionId === question.id);
                if (resObj) {
                  if (resObj.questionName === "MultiChoice" || resObj.questionName === "Image") {
                    question.answer = resObj.answerText;
                    const optionsIds = _.cloneDeep(resObj.optionsIds);
                    question.optionsIds = resObj.optionsIds ? optionsIds : [];
                    question.subType = resObj.subType;
                  } else if (resObj.questionName === "DateTime") {
                    question.answer = resObj.answerText;
                    question.date = resObj.date;
                    question.time = resObj.time;
                    question.dateFormat = resObj.dateFormat;
                    question.timeFormat = resObj.timeFormat;
                  } else if (resObj.questionName == "Boolean") {
                    question.answer = resObj.answerText;
                    question.answerId = resObj.answerId;
                  } else if (resObj.questionName == "Log") {
                    question.multiAnswer = _.cloneDeep(resObj.multiAnswer);
                    question.answerId = resObj.answerId;
                  } else if (resObj.questionName == "DropDown") {
                    question.answer = resObj.answerText;
                    question.optionId = resObj.optionId;
                    question.index = resObj.index;
                    question.answerId = resObj.answerId;
                  } else {
                    question.answer = resObj.answerText;
                  }
                  question.computedScore = resObj.score || 0;
                  question.actualScore = resObj.actualScore || 0;
                } else {
                  question.answer = "";
                  if (question.type != "Section") {
                    question.computedScore = 0;
                    question.actualScore = 0;
                  }
                }
              });
              const activityData = {};
              activityData.id = unscheduleform.form;
              this.answersObj.push({
                formName: unscheduleform.form.name,
                type: unscheduleform.form.type,
                formData: unscheduleform.form,
                formId: unscheduleform.form.id
              });
            }
          });
          this.generalInfo = {
            formId: this.formData.id,
            createdTime: this.alreadySavedUnscheduleForms && this.alreadySavedUnscheduleForms.createdAt ? this.alreadySavedUnscheduleForms.createdAt : this.formData.activity.createdTime,
            formName: this.unschedulePackets && this.unschedulePackets.length > 0 ? this.unschedulePackets[0].packetName : this.formData.name,
            approvalStatus: this.alreadySavedUnscheduleForms.approvalStatus,
            verificationStatus: this.alreadySavedUnscheduleForms.verificationStatus,
            lockStatus: this.alreadySavedUnscheduleForms.lockStatus,
            signoffStatus: this.alreadySavedUnscheduleForms.signoffStatus,
            reviewStatus: this.alreadySavedUnscheduleForms.reviewStatus,
            numberOfOpenQueries: null,
            numberOfClosedQueries: null,
            verifiedOn: 0,
            approvedOn: 0,
            submittedOn: null,
            comments: null
          };
        })
        .catch(error => {
          if (error && (error.message || error.body.message)) {
            this.$toastr.error(error.message || error.body.message);
          } else {
            this.$toastr.error("Unable to fetch the unscheduled packets");
          }
        });
    },
    // save the edited forms in the packet
    updateUnschedulePacket(changeReason, queryId) {
      this.triggerValidate = !this.triggerValidate;
      const currentEdcFormErrors = JSON.parse(window.localStorage.getItem("thread-edcFormErrors")) || [];
      if (find(currentEdcFormErrors, ["comment", true]) || find(currentEdcFormErrors, ["time", true]) || find(currentEdcFormErrors, ["date", true])) {
        this.formSubmitted = this.formSubmitted + 1;
        this.$toastr.error("Please populate required fields.");
      } else {
        this.responses = [];
        let answersPreviouslySaved = [];
        // loop over entire forms array and generate the answers for each form
        this.formErrors = [];
        this.unscheduledForms.forEach((unscheduleForm, formIndex) => {
          // intialize answers as empty array if no answers
          if (unscheduleForm.response.answers) {
            answersPreviouslySaved = unscheduleForm.response.answers || [];
          }
          this.currentFormResoponse = [];

          if (unscheduleForm.form.type == "EDC") {
            // generate answers array
            unscheduleForm.form.fields.forEach(field => {
              this.unscheduledForms[formIndex].response.state = "SUBMITTED";
              this.unscheduledForms[formIndex].response.answers = [];
              this.generateAnswerFormat(field.name, field, answersPreviouslySaved, formIndex);
            });
          } else {
            this.unansweredQuestions = [];
            unscheduleForm.form.activity.questions.forEach(question => {
              this.unscheduledForms[formIndex].response.state = "SUBMITTED";
              this.unscheduledForms[formIndex].response.answers = [];
              activityService.generateActivityAnswerFormat(question, answersPreviouslySaved, this.currentFormResoponse, this.unansweredQuestions);
            });
          }
          // attach generated answers array to intialized answers array
          if (this.currentFormResoponse.length) {
            this.unscheduledForms[formIndex].response.answers = this.currentFormResoponse;
          }
        });
        // loop over the unschedule forms to check whether the required fields are filled or not
        this.unscheduledForms.forEach((unscheduleForm, formIndex) => {
          // get all required fields for each form
          if (unscheduleForm.form.type == "EDC") {
            const requiredFieldIds = unscheduleForm.form.fields.filter(field => field.required === true).map(field => field.id);
            // get all the answers filled for each form
            const answersIds = unscheduleForm.response.answers.map(answer => answer.questionId);
            if (difference(requiredFieldIds, answersIds).length && answersIds.length) {
              this.formSubmitted = this.formSubmitted + 1;
              this.formErrors.push({
                formId: unscheduleForm.form.id,
                formName: unscheduleForm.form.name,
                errorMsg: `Please fill all the required fields in the form ${unscheduleForm.form.name}.`
              });
            }

            this.diffResp = [];
            unscheduleForm.form.fields.forEach(field => {
              // get the old and new answers given by user
              const oldAnsField = find(this.modifiedUnscheduledForms[formIndex].response.answers, ["questionId", field.id]);
              const newAnsField = find(unscheduleForm.response.answers, ["questionId", field.id]);
              // Update the diffResp array if any of the answer ( old or new ) is not present
              if (oldAnsField && !newAnsField) {
                this.diffResp.push(field.id);
              } else if (!oldAnsField && newAnsField) {
                this.diffResp.push(field.id);
              } else if (oldAnsField && newAnsField) {
                // Check optionId's of old new new answers
                if (oldAnsField.optionId !== newAnsField.optionId) {
                  this.diffResp.push(field.id);
                } else if (field.name === "formDateTime") {
                  // Check answer date and time and update the flag if changed
                  if (oldAnsField.date !== newAnsField.date || oldAnsField.time !== newAnsField.time || oldAnsField.timezone !== newAnsField.timezone) {
                    this.diffResp.push(field.id);
                  }
                } else if (field.name === "formCheckbox") {
                  // Check for answers length update the flag if lengths are different
                  const newCommentsAns = newAnsField.multiAnswer.map(multiAns => multiAns.comment);
                  const existingCommentsAns = oldAnsField.multiAnswer.map(multiAns => multiAns.comment);
                  if (newCommentsAns[0] !== undefined && (difference(newCommentsAns, existingCommentsAns).length > 0 || difference(existingCommentsAns, newCommentsAns).length > 0)) {
                    this.diffResp.push(field.id);
                  } else if (oldAnsField.multiAnswer.length === newAnsField.multiAnswer.length) {
                    // If answers length are equal check for the option Id's
                    // if changed and update the status
                    const existingAns = oldAnsField.multiAnswer.map(multiAns => multiAns.optionId);
                    const newAns = newAnsField.multiAnswer.map(multiAns => multiAns.optionId);
                    if (difference(newAns, existingAns).length > 0 || difference(existingAns, newAns).length > 0) {
                      this.diffResp.push(field.id);
                    }
                    // If answers length and options ID's are equal check for the comments
                    // if changed and update the status
                    const existingCommentsAns = oldAnsField.multiAnswer.map(multiAns => multiAns.comment);
                    if (difference(newCommentsAns, existingCommentsAns).length > 0 || difference(existingCommentsAns, newCommentsAns).length > 0) {
                      this.diffResp.push(field.id);
                    }
                  }
                } else if (field.name === "formTable") {
                  // Check for answers length update the flag if lengths are different
                  if (oldAnsField.multiAnswer.length !== newAnsField.multiAnswer.length || (!newAnsField.multiAnswer.length && oldAnsField.multiAnswer.length > 0) || (newAnsField.multiAnswer.length && !oldAnsField.multiAnswer.length)) {
                    this.diffResp.push(field.id);
                  } else if (oldAnsField.multiAnswer.length === newAnsField.multiAnswer.length) {
                    // If answers length are equal check for the answerTexts
                    // if changed and update the status
                    const existingAns = oldAnsField.multiAnswer.map(multiAns => multiAns.answerText);
                    const newAns = newAnsField.multiAnswer.map(multiAns => multiAns.answerText);
                    if (difference(newAns, existingAns).length > 0 || difference(existingAns, newAns).length > 0) {
                      this.diffResp.push(field.id);
                    }
                  }
                } else if (field.name === "formTextArea" || field.name === "formScale" || field.name === "formTextNumeric") {
                  // Check answer text of old new new answers
                  if (oldAnsField.answerText !== newAnsField.answerText) {
                    this.diffResp.push(field.id);
                  }
                  // Check answer's comment of old new new answers if present
                  if (oldAnsField.comment && newAnsField.comment) {
                    if (oldAnsField.comment !== newAnsField.comment) {
                      this.diffResp.push(field.id);
                    }
                  } else if ((!newAnsField.comment && oldAnsField.comment) || (newAnsField.comment && !oldAnsField.comment)) {
                    this.diffResp.push(field.id);
                  }
                } else if (field.name === "formDropdown" || field.name === "formSinglechoice") {
                  // Check answer text of old new new answers
                  if (oldAnsField.comment && newAnsField.comment && oldAnsField.comment !== newAnsField.comment) {
                    this.diffResp.push(field.id);
                  }
                }
              }
            });
            this.unscheduledForms[formIndex].editedFields = this.diffResp;
          } else {
            this.diffResp = [];
            let requiredFieldIds = unscheduleForm.form.activity.questions.filter(question => !this.unsupportedQuestionType.includes(question.type) && question.isSkippable == false).map(question => question.id);
            requiredFieldIds = this.removeDisabledFieldsFromRequiredFields(unscheduleForm.form.id, requiredFieldIds);
            const answersIds = unscheduleForm.response.answers
              .filter(it => requiredFieldIds.indexOf(it.questionId) > -1)
              .filter(o => o.answerText !== null || o.date !== null || o.time !== null || o.multiAnswer.length > 0)
              .map(answer => {
                return answer.questionId;
              });
            if (difference(requiredFieldIds, answersIds).length && answersIds.length) {
              this.formSubmitted = this.formSubmitted + 1;
              this.formErrors.push({
                formId: unscheduleForm.form.id,
                formName: unscheduleForm.form.name,
                errorMsg: `Please fill all the required fields in the form ${unscheduleForm.form.name}.`
              });
            }

            unscheduleForm.form.activity.questions.forEach(question => {
              if (question.hasFieldError) {
                this.formErrors.push({
                  formId: unscheduleForm.form.id,
                  formName: unscheduleForm.form.name,
                  errorMsg: "Please fill valid data"
                });
              }
            });

            // Write the logic to get difference between current and old answer

            unscheduleForm.form.activity.questions.forEach(question => {
              const oldAnswer = find(this.modifiedUnscheduledForms[formIndex].response.answers, ["questionId", question.id]);

              if (question.type == "MultiChoice" || question.type == "Image") {
                if (!oldAnswer) {
                  if (question.optionsIds && question.optionsIds.length) {
                    this.diffResp.push(question.id);
                  }
                } else {
                  if (question.optionsIds instanceof Array) {
                    const currentOptionIds = question.optionsIds;
                    const oldOptionIds = oldAnswer.optionsIds;

                    if (currentOptionIds.length != (oldOptionIds && oldOptionIds.length)) {
                      this.diffResp.push(question.id);
                    } else if (difference(currentOptionIds, oldOptionIds).length) {
                      this.diffResp.push(question.id);
                    }
                  }
                }
              } else if (question.type == "Log") {
                if (!oldAnswer) {
                  if (question.multiAnswer && question.multiAnswer.length) {
                    this.diffResp.push(question.id);
                  }
                } else {
                  const isDiff = activityService.getDiffOfArray(oldAnswer.multiAnswer, question.multiAnswer);
                  if (isDiff) {
                    this.diffResp.push(question.id);
                  }
                }
              } else if (question.type == "Boolean") {
                if (!oldAnswer) {
                  if (question.answerId || question.answerId === 0) {
                    this.diffResp.push(question.id);
                  }
                } else {
                  if (question.answerId != oldAnswer.answerId) {
                    this.diffResp.push(question.id);
                  }
                }
              } else if (question.type == "DateTime") {
                if (!oldAnswer) {
                  if (question.date || question.time) {
                    this.diffResp.push(question.id);
                  }
                } else {
                  if (question.date != oldAnswer.date || question.time != oldAnswer.time) {
                    this.diffResp.push(question.id);
                  }
                }
              } else if (question.type == "CompletionQuestion") {
                // Do nothing
              } else {
                if (!oldAnswer) {
                  if (question.answer || question.answer === 0) {
                    this.diffResp.push(question.id);
                  }
                } else {
                  if (question.answer != oldAnswer.answerText) {
                    this.diffResp.push(question.id);
                  }
                }
              }
            });

            this.unscheduledForms[formIndex].editedFields = this.diffResp;
            //this code need to be removed once backend advanced scoring changes are removed
            let responseScore = {};
            responseScore.totalScore = 0;
            responseScore.sectionScores = {};
            this.unscheduledForms[formIndex].response.totalScore = responseScore.totalScore;
            this.unscheduledForms[formIndex].response.sectionScores = responseScore.sectionScores;
            //this code need to be removed once backend advanced scoring changes are removed
          }
        });
        if (this.formErrors.length) {
          this.$toastr.error(this.formErrors[0].errorMsg);
        } else {
          const areFieldsEdited = uniq(map(this.unscheduledForms, form => form.editedFields && form.editedFields.length > 0));
          const fieldsEditedFlag = areFieldsEdited[1] ? areFieldsEdited[0] || areFieldsEdited[1] : areFieldsEdited[0];
          if (!fieldsEditedFlag) {
            this.$toastr.error("No new changes were made to the packet.");
          } else if (this.valdateRequiredFields() === "requiredError") {
            this.$toastr.error("Please fill all required data.");
          } else if (this.valdateRequiredFields() === "invalidData") {
            this.$toastr.error("Please fill Valid Data.");
          } else if (this.formData.type === "EDC") {
            const updateData = {
              participantId: this.participantId,
              unscheduledPacketId: this.packetId,
              unscheduledPacketVersionId: this.alreadySavedUnscheduleForms.unscheduledVersionId,
              state: "SUBMITTED",
              packetFormResponses: this.unscheduledForms,
              primaryReason: changeReason,
              taskInstanceId: this.taskInstanceId,
              queryId: queryId
            };
            updateData.milestone = this.milestone;
            updateData.unscheduledPacketResponseId = this.unscheduledPacketResponseId;
            updateData.unscheduledPacketResponseVersionId = this.alreadySavedUnscheduleForms.unscheduledPacketResponseVersionId;
            updateData.unscheduledPacketVersionId = this.alreadySavedUnscheduleForms.unscheduledPacketVersionId;
            this.isSaveButtonDisabled = true;
            this.$api
              .updateEDCUnscheduleFormResponseFactV2(this.packetId, this.studyId, this.participantId, this.unscheduledPacketResponseId, updateData)
              .then(response => {
                if (response.body.unscheduledPacketResponseId) {
                  // clear all the available errorflags from Vue store
                  this.clearEDCFormErrors();
                  this.edit = false;
                  this.getEDCUnscheduledPacketForms(true);
                  // get the form history versions
                  this.getEDCFormHistoryList();
                } else {
                  this.$toastr.error("Unable to submit your response, Please try again.");
                }
              })
              .catch(error => {
                if (error && (error.message || error.body.message)) {
                  this.$toastr.error(error.message || error.body.message || "Unable to submit your response, Please try again.");
                }
              })
              .finally(() => {
                this.isSaveButtonDisabled = false;
              });
          } else {
            const updateData = {
              participantId: this.participantId,
              unscheduledPacketId: this.packetId,
              unscheduledPacketVersionId: this.alreadySavedUnscheduleForms.unscheduledVersionId,
              state: "SUBMITTED",
              packetFormResponses: this.unscheduledForms,
              primaryReason: changeReason,
              taskInstanceId: this.taskInstanceId,
              queryId: queryId
            };
            updateData.milestone = this.milestone;
            updateData.unscheduledPacketResponseId = this.unscheduledPacketResponseId;
            updateData.unscheduledPacketResponseVersionId = this.alreadySavedUnscheduleForms.unscheduledPacketResponseVersionId;
            updateData.unscheduledPacketVersionId = this.alreadySavedUnscheduleForms.unscheduledPacketVersionId;
            this.isSaveButtonDisabled = true;
            this.$api
              .updateEDCUnscheduleFormResponseFactV3(this.packetId, this.studyId, this.participantId, this.unscheduledPacketResponseId, updateData)
              .then(response => {
                if (response.body.unscheduledPacketResponseId) {
                  // clear all the available errorflags from Vue store
                  this.clearEDCFormErrors();
                  this.edit = false;
                  this.getEDCUnscheduledPacketForms(true);
                  // get the form history versions
                  this.getEDCFormHistoryList();
                } else {
                  this.$toastr.error("Unable to submit your response, Please try again.");
                }
              })
              .catch(error => {
                if (error && (error.message || error.body.message)) {
                  this.$toastr.error(error.message || error.body.message || "Unable to submit your response, Please try again.");
                }
              })
              .finally(() => {
                this.isSaveButtonDisabled = false;
              });
          }
        }
      }
    },
    // get answer format for the field given
    generateAnswerFormat(fieldName, field, answers) {
      switch (fieldName) {
        case "formDropdown": {
          if (field.answer) {
            const answerSelected = find(field.options, ["id", field.answer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const dropDownResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              index: answerSelected.index,
              comment: ""
            };
            if (isAnswerAlreadySaved) {
              dropDownResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              dropDownResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(dropDownResponse);
          }
          break;
        }
        case "formCheckbox": {
          const checkBoxResponse = {
            questionId: field.id,
            questionName: field.name,
            multiAnswer: []
          };
          const areAnswersAlreadySaved = find(answers, ["questionId", field.id]);
          field.options.forEach(option => {
            if (option.answer && option.answer.selected) {
              const tempCheckBoxResponse = {
                optionId: option.id,
                answerText: option.label,
                index: option.index
              };
              if (option.type === "Other" && option.commentField) {
                tempCheckBoxResponse.comment = option.comment.commentMessage;
              }
              checkBoxResponse.multiAnswer.push(tempCheckBoxResponse);
            }
          });
          if (areAnswersAlreadySaved) {
            checkBoxResponse.answerId = areAnswersAlreadySaved.answerId;
          }
          if (checkBoxResponse.multiAnswer.length > 0) {
            this.currentFormResoponse.push(checkBoxResponse);
          }
          break;
        }
        case "formTextNumeric": {
          if (field.answer) {
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const textNumericResponse = {
              questionId: field.id,
              questionName: field.name,
              answerText: field.answer
            };
            if (isAnswerAlreadySaved) {
              textNumericResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            this.currentFormResoponse.push(textNumericResponse);
          }
          break;
        }
        case "formSinglechoice": {
          if (field.answer) {
            const answerSelected = find(field.options, ["id", field.answer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const singleChoiceResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              index: answerSelected.index,
              comment: ""
            };
            if (isAnswerAlreadySaved) {
              singleChoiceResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              singleChoiceResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(singleChoiceResponse);
          }
          break;
        }
        case "formScale": {
          if (field.answer && !field.nonScaleAnswer) {
            const answerSelected = find(field.options, ["label", field.answer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const scaleResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              weight: answerSelected.weight,
              index: answerSelected.index
            };
            if (isAnswerAlreadySaved) {
              scaleResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              scaleResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(scaleResponse);
          }
          if (field.nonScaleAnswer) {
            const answerSelected = find(field.options, ["label", field.nonScaleAnswer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const scaleResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              index: answerSelected.index,
              weight: answerSelected.weight
            };
            if (isAnswerAlreadySaved) {
              scaleResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              scaleResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(scaleResponse);
          }
          break;
        }
        case "formDateTime": {
          const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
          const dateTimeResponse = {
            questionId: field.id,
            questionName: field.name,
            timezone: field.timezone
          };
          if (isAnswerAlreadySaved) {
            dateTimeResponse.answerId = isAnswerAlreadySaved.answerId;
          }
          if (field.collectDate && field.dateField.format) {
            const dateFormat = pull(uniq(field.dateField.format), "/").join("");
            dateTimeResponse.date = "";
            dateFormat.split("").forEach(val => {
              if (val === "M" && field.month) {
                dateTimeResponse.date += `${field.month}/`;
              }
              if (val === "Y" && field.year) {
                dateTimeResponse.date += `${field.year}/`;
              }
              if (val === "D" && field.date) {
                dateTimeResponse.date += `${field.date}/`;
              }
            });
            if (dateTimeResponse.date.length > 0) {
              dateTimeResponse.date = dateTimeResponse.date.slice(0, -1);
            }
          }
          if (field.collectTime && field.timeField.format) {
            if (field.timeField.format === "hh:mm a" && field.time.hh && field.time.mm) {
              dateTimeResponse.time = `${field.time.hh}:${field.time.mm} ${field.meridian}`;
            }
            if (field.timeField.format === "HH:mm" && field.time.HH && field.time.mm) {
              dateTimeResponse.time = `${field.time.HH}:${field.time.mm}`;
            }
          }
          if ((dateTimeResponse.date && dateTimeResponse.date.length > 0) || (dateTimeResponse.time && dateTimeResponse.time.length > 0)) {
            this.currentFormResoponse.push(dateTimeResponse);
          }
          break;
        }
        case "formTable": {
          const tableResponse = {
            questionId: field.id,
            questionName: field.name,
            multiAnswer: []
          };
          const areAnswersAlreadySaved = find(answers, ["questionId", field.id]);
          field.fields.forEach(option => {
            if (option.label) {
              tableResponse.multiAnswer.push({
                answerText: option.label
              });
            }
          });
          field.addFields.forEach(option => {
            if (option.label) {
              tableResponse.multiAnswer.push({
                answerText: option.label
              });
            }
          });
          if (areAnswersAlreadySaved) {
            tableResponse.answerId = areAnswersAlreadySaved.answerId;
          }
          if (tableResponse.multiAnswer.length > 0) {
            this.currentFormResoponse.push(tableResponse);
          }
          break;
        }
        case "formTextArea": {
          if (field.answer) {
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const textAreaResponse = {
              questionId: field.id,
              questionName: field.name,
              answerText: field.answer
            };
            if (isAnswerAlreadySaved) {
              textAreaResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            this.currentFormResoponse.push(textAreaResponse);
          }
          break;
        }
        default:
          break;
      }
    },

    goToPreviousScreen() {
      const studyID = this.studyId;
      this.$router.push({
        name: "study-participant-details",
        params: { studyID, participantId: this.participantId }
      });
    },

    updateComment(queryId, fieldId) {
      this.selectedId = fieldId;
      this.$api.getAllQueryComments(queryId, this.formStudyId).then(response => {
        this.comments = response.body.comments;
      });
    },

    // update the flag from the form fields after the form submitted
    formSubmittedFlag(value) {
      this.formSubmitted = value;
    },
    openTab(tabNumber) {
      switch (tabNumber) {
        case 1:
          this.sourceDocumentsOpen = false;
          break;
        case 2:
          this.sourceDocumentsOpen = false;
          break;
        case 3:
          this.sourceDocumentsOpen = true;
          break;
        case 4:
          this.sourceDocumentsOpen = false;
          break;
      }
    },
    getSourceDocuments() {
      this.$api.getSourceDocumentsFact(this.studyId, this.participantId, this.unscheduledPacketResponseId, this.participantInfo.siteId).then(
        response => {
          this.documentsList = orderBy(response.body, "name");
          this.documentsList.forEach(document => {
            const documentIndex = findIndex(this.siteTeamDetails, ["id", document.createdBy]);
            document.createdByName = this.siteTeamDetails[documentIndex].name;
            const createdByRole = this.siteTeamDetails[documentIndex].userRole;
            if (createdByRole === "Cra") {
              document.createdByUserRole = "CRA(B)";
            } else if (createdByRole === "CraUB") {
              document.createdByUserRole = "CRA(U)";
            } else if (createdByRole === "Pi") {
              document.createdByUserRole = "PI";
            } else if (createdByRole === "SubPi") {
              document.createdByUserRole = "Sub-I";
            } else if (createdByRole === "StudyCoordinator") {
              document.createdByUserRole = "SC";
            } else if (createdByRole === "HomeHealth") {
              document.createdByUserRole = "Home Health";
            } else if (createdByRole === "CallCenter") {
              document.createdByUserRole = "Call Center";
            }
            const fileSize = (document.size / 1024).toFixed(2);
            if (fileSize < 1024) {
              document.fileSize = fileSize + " KB";
            } else {
              document.fileSize = (fileSize / 1024).toFixed(2) + " MB";
            }
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting source documents");
        }
      );
    },
    toggleParticipant(participant) {
      const params = {
        studyId: this.studyId,
        packetId: this.packetId,
        unscheduledPacketResponseId: this.unscheduledPacketResponseId,
        responseType: this.responseType
      };
      this.$router.push({ name: "submitted-packets-reskin", params: params });
      this.participantId = participant.id;
      this.getSiteTeam();
    },
    onLanguageChange(lang) {
      this.selectedLanguageCulture = lang;
      for (let index = 0; index < this.languages.length; index++) {
        if (lang == this.languages[index].language_culture) {
          this.selectedLanguageId = this.languages[index].language_id;
          this.getApplangaData(this.languages[index].language_id);
        }
      }
    },
    getApplangaData(languageId) {
      this.$nextTick(() => {
        this.mlService.getCSSRTranslation(this.$route.params.studyId, languageId);
      });
    },
    validateDataForScoring(currentFormData) {
      this.response = [];
      let answersPreviouslySaved = [];
      if (this.formResponses) {
        answersPreviouslySaved = this.formResponses.answers || [];
      }
      if (currentFormData.type == "EDC") {
        currentFormData.fields.forEach(field => {
          this.generateAnswerFormat(field.name, field, answersPreviouslySaved);
        });
        currentFormData.fields.filter(field => field.required === true).map(field => field.id);
      } else {
        if (currentFormData) {
          this.unansweredQuestions = [];
          currentFormData.activity.questions.forEach(question => {
            activityService.generateActivityAnswerFormat(question, answersPreviouslySaved, this.response, this.unansweredQuestions);
          });

          currentFormData.activity.questions.filter(question => question.type != "Section" && question.type != "SurveyCompletion" && question.isSkippable == false).map(question => question.id);
          //this code need to be removed once backend advanced scoring changes are removed
          let responseScore = {};
          responseScore.totalScore = 0;
          responseScore.sectionScores = {};
          this.$set(this.responseScores, currentFormData.id, responseScore);
          //this code need to be removed once backend advanced scoring changes are removed
        }
      }
    },
    onValidateAnswer() {
      this.showValidationMessage = false;
    },
    valdateRequiredFields() {
      let hasError = "";
      if (this.unscheduledForms) {
        this.unscheduledForms.map(unscheduledForm => {
          unscheduledForm.form.activity.questions.map(question => {
            if (!question.isSkippable && question.type !== "SurveyCompletion" && !(this.disabledFieldsByBranchingLogic[unscheduledForm.form.id] && this.disabledFieldsByBranchingLogic[unscheduledForm.form.id][question.id])) {
              if (activityService.validateRequiredFields(question)) {
                hasError = "requiredError";
              }
            }
            if (question.isSkippable && question.type == "Log" && activityService.checkLogEntryEmptyAnswers(question) && !this.disabledFieldsByBranchingLogic[unscheduledForm.form.id][question.id]) {
              hasError = "invalidData";
            }
          });
        });
      }
      return hasError;
    },
    getActivityVariablesList() {
      this.activityRevisionId = this.formData.activity.id;
      let that = this;
      activityService.getActivityVariablesList(this.activityRevisionId)
        .then(res => {
          that.variablesList = res;
        }, error => {
          this.$toastr.error(
            error.body && error.body.message
              ? error.body.message
              : "Error while getting variable list."
          );
        });
    },
  },
  mounted() {
    this.getSiteTeam();
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables.scss";

.component {
  background-color: #fff;
}

.back-button {
  font-size: 14px;
  padding-top: 0px;
  padding-left: 0px;
  margin-bottom: 20px;
}

.editing {
  text-transform: uppercase;
  font-size: 12px;
  color: #7478e6;
}
</style>
<style lang="scss">
.study-particip-form-block {
  .nav-tabs {
    border-bottom-color: #d3dfe4;
    .nav-item {
      margin: 0 17px;
    }

    .nav-link {
      font-size: 14px;
      line-height: 1.43;
      color: #2d3752;
      padding: 0.9rem 0 0.45rem !important;
      border: none;
      border-bottom: 4px solid transparent;

      &:focus,
      &:hover {
        border: none;
        border-bottom: 4px solid transparent;
      }

      &:hover {
        border-bottom: 4px solid #4c8ce4;
      }

      &.active {
        font-weight: bold;
        border-bottom: 4px solid #4c8ce4;
      }
    }
  }

  .tabs-queries {
    border-left: 1px solid #d3dfe4;

    .nav-tabs {
      margin-left: -1px;
      border-left: 1px solid #fff;
      flex-wrap: inherit;
    }
  }
}

@media (max-width: 1400px) {
  .study-particip-form-block {
    .nav-tabs {
      .nav-item {
        margin: 0 10px;
      }
    }
  }
}
.clear-float {
  clear: both;
}
.primaryBgColor {
  background-color: #1e8fe1;
}
.telehealth-call {
  .study-particip-form-block .nav-tabs .nav-link {
    font-size: 12px;
  }
}
.d-inline-block.score_total {
  width: 75%;
  text-align: right;
  line-height: 36px;
}
</style>
